import React, {PureComponent} from 'react'
import Store from 'Store'
import {inject, observer} from 'mobx-react'
import {loading} from 'elements/Loading'
import {Form} from 'components'
import {FieldType} from 'elements'
import {rules} from 'helpers/Validation'
import OperationLines from '../Model'
import IconosApp, {Iconos} from '../../../elements/IconosApp'

interface Props {
  store?: Store
  match: any
  operationLine: OperationLines
}

@inject('store')
@loading<Props>(props => [
  props.match.params.id
    ? props.store!.operationLines.read(props.match.params.id).then(operationLine => ({operationLine}))
    : undefined,
  props.store!.businessUnits.read(),
  props.store!.receipLayouts.read(),
  props.store!.taxes.read()
])
@observer
export default class OperationLinesForm extends PureComponent<Props, object> {

  fields = [
    {
      name: 'name',
      type: FieldType.Text,
      rules: rules()
        .string()
        .required(),
      size: 4
    },
    {
      name: 'code',
      type: FieldType.Text,
      rules: rules()
        .string()
        .required(),
      size: 4
    },
    {
      name: 'businessUnit',
      column: 'businessUnit_id',
      type: FieldType.Select,
      rules: rules()
        .number()
        .required(),
      size: 4,
      options: this.props.store!.businessUnits.data.map(item => {
        // console.log('item', item)
        return {
          value: String(item.id),
          name: item.name
        }
      })
    },
    {
      name: 'receiptLayout',
      column: 'receiptLayout_id',
      type: FieldType.Select,
      rules: rules()
        .number(),
      size: 2,
      options: this.props.store!.receipLayouts.data.map(item => {
        // console.log('item', item)
        return {
          value: String(item.id),
          name: item.code
        }
      })
    },
    {
      name: 'tax',
      column: 'tax_id',
      type: FieldType.Select,
      rules: rules()
        .number(),
      size: 2,
      options: this.props.store!.taxes.taxes.map(item => {
        // console.log('item', item)
        return {
          value: String(item.id),
          name: item.name
        }
      })
    },
    {
      name: 'description',
      type: FieldType.TextArea,
      rules: rules()
        .string(),
      size: 12,

    },
    {
      name: 'icon',
      type: FieldType.Icon,
      rules: rules()
        .string(),
      size: 12,
      icons: Iconos
    }

  ]

  render() {
    const {operationLine} = this.props
    const operationLines = this.props.store!.operationLines
    // console.log('Iconos en render', Iconos)
    // console.log('this.props.businessUnits', this.props.businessUnits)
    return (
      <div>
        <Form
          loading={['post@operationlines/', 'put@operationlines/']}
          fields={this.fields}
          values={operationLine}
          store={operationLines}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/OperationLines/container/OperationLinesForm.tsx